export default __webpack_public_path__ + "31d35e437187069414f011f008a5e2fc.png";